var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.05 7.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7,5.04l-1.52-1.52,1.52-1.52c.46-.46,.46-1.2,0-1.66s-1.2-.46-1.66,0l-1.52,1.52L2.01,.34c-.46-.46-1.2-.46-1.66,0S-.11,1.55,.34,2.01l1.52,1.52L.34,5.04c-.46,.46-.46,1.2,0,1.66s1.2,.46,1.66,0l1.52-1.52,1.52,1.52c.46,.46,1.2,.46,1.66,0s.46-1.2,0-1.66Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.21a3f5dceef3cb799288afa40db9e6de.svg";
export { ForwardRef as ReactComponent };